import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from "@razorpay/blade/components";
import React from "react";

export const ChangeAccountConfirmationModal = ({
  isOpen,
  onDismiss,
  onContinue,
}: {
  isOpen: boolean;
  onDismiss: () => void;
  onContinue: () => void;
}) => {

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size="small">
      <ModalHeader
        title="Change bank account details?"
      />
      <ModalBody>
        <Text color="surface.text.gray.normal">
          Your previously saved bank account information will be replaced.
          You’ll need to enter your new details to continue. Are you sure you
          want to proceed?
        </Text>
      </ModalBody>
      <ModalFooter>
        <Box
          display="flex"
          gap="spacing.5"
          justifyContent="flex-end"
          width="100%"
        >
          <Button variant="tertiary" onClick={onDismiss}>
            Cancel
          </Button>
          <Button variant="secondary" color="negative" onClick={onContinue}>
            Change Account
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}

